<template>
  <div class="verify-2fa">
    <Loader v-if="loading" />
    <!-- <Alert type="danger" :messages="errors" /> -->
    <div
      class="d-flex flex-column align-items-center"
      style="justify-content: space-between; gap: 100px;"
    >
      <div
        class="alert d-inline-flex"
        :class="`alert-danger`"
        role="alert"
        v-if="errors.length"
      >
        <span
          v-for="(message, index) in errors"
          v-html="message"
          :key="index"
        ></span>
      </div>

      <div class="button-container" v-if="errors.length">
        <button class="btn btn-primay btn-teal">ログイン画面へ戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/utils/Alert.vue';
import FieldError from '@/components/utils/FieldError.vue';
import actions from '@/config/actions';
import { mapActions } from 'vuex';
import Api from '@/config/api';
import axios from '@/http';
import Loader from './utils/Loader.vue';

export default {
  name: 'Verify2FA',
  components: { FieldError, Alert, Loader },
  data() {
    return {
      message: 'Verifying your login...',
      errors: [],
      loading: true,
    };
  },
  methods: {
    ...mapActions([actions.auth.LOGIN, actions.auth.LOGGED_IN]),
  },

  async mounted() {
    this.changeBodyToWhite();
    console.log(this.loading);
    // this.loading = true;
    const { token } = this.$route.query;
    if (!token) {
      this.errors = 'No verification token provided';
      return;
    }

    try {
      const response = await axios.get(Api.endpoints.VERIFY_2FA, {
        params: { token },
      });
      const { access_token, refresh_token, expires_in } = response.data;

      this[actions.auth.LOGGED_IN](response.data);
      // Store tokens (e.g., in Vuex or localStorage)
      this.$router.push('/applicant');
      // Redirect to dashboard or home
      //   this.$router.push({ name: 'Dashboard' });
    } catch (error) {
      console.log(error.response);
      const response = error.response;
      this.errors = [];
      if (response.status === 400) {
        return this.errors.push(
          '本人認証用リンクが無効です。再度ログイン画面よりログインを試行し、認証用リンクを新規発行してください。'
        );
      }
      if (response.status === 401)
        return this.errors.push(
          response.data == 'Unauthorized'
            ? response.data
            : response.data.data.message
            ? response.data.data.message
            : response.data.error_description
        );
      if (response.status === 402)
        return this.errors.push(
          'アカウントがブロックされています。管理者にお問い合わせ下さい。'
        );
      if (response.status === 403)
        return this.errors.push('IDまたはパスワードが間違っています。');
      if (response.status === 503)
        return this.errors.push(
          response.data.message
            ? response.data.message
            : response.data.error_description
        );
      return this.parseErrorResponse(response);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.verify-2fa {
  text-align: center;
  padding: 50px;
}
.error {
  color: red;
}
.alert-danger {
  margin-top: 50px;
  font-size: 24px;
  border-radius: 10px;
  padding: 50px 30px;
  text-align: left;
}
.btn-teal {
  background-color: #006c6b;
  border-radius: 4px;
  color: #fff;
  padding: 15px 80px;
}
</style>
